import { combine, withContext } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { spec, validators } from 'utils/validation'

import { StoreContext } from 'store/context'
import ChangePasswordFormComponent from './component'

const { any, custom, string } = validators

export const ChangePasswordForm = combine({
  hooks: [
    withContext('appStore', StoreContext),
    withFormModel(
      {
        oldPassword: {
          alias: 'Old password',
          spec: spec.flow(string.isString, string.isNotEmpty, any.required),
        },

        newPassword: {
          alias: 'New password',
          spec: spec.flow(string.isString, string.isNotEmpty, any.required),
        },

        confirmation: spec.flow(
          string.isString,
          custom.matchProp({ key: 'newPassword', alias: 'New Password' }),
          string.isNotEmpty,
          any.required
        ),
      },
      { id: 'change-password' }
    ),
  ],
  transformProps: ({ appStore, ...rest }) => {
    return {
      ...rest,
      appConfig: appStore.appConfig,
    }
  },
})(ChangePasswordFormComponent)
